import React from "react"
import { NotificationRow } from "./NotificationRow"

interface User {
  id: number
  send_notification_emails: boolean
  send_notification_texts: boolean
  send_weekly_digest_emails: boolean
  send_discovery_emails: boolean
}

interface NotificationTableProps {
  user: User
}

export const NotificationTable: React.FC<NotificationTableProps> = ({
  user,
}) => {
  return (
    <div className="grid grid-cols-12 mt-6">
      <div className="lg:col-span-11 col-span-12">
        <table className="w-full">
          <thead>
            <tr className="border-b">
              <th className="text-left py-2">Notification Type</th>
              <th className="text-center py-2">Email</th>
              <th className="text-center py-2">Text</th>
            </tr>
          </thead>
          <tbody>
            <NotificationRow
              user={user}
              label="Notifications & Reminders"
              description="notifications about new comments on threads you follow, and reminders about events you responded to"
              emailsName="send_notification_emails"
              textsName="send_notification_texts"
            />
            <NotificationRow
              user={user}
              label="Band Notifications"
              description="important band notifications, like getting added to Playlists, play statistics, and payments"
              emailsName="send_band_notification_emails"
            />
            <NotificationRow
              user={user}
              label="Weekly Digest"
              description="these go out weekly, but only with new stuff (albums/videos/streams) from bands you follow"
              emailsName="send_weekly_digest_emails"
            />
            <NotificationRow
              user={user}
              label="Product Updates"
              description="these go out sporadically as we make significant updates to bandNada"
              emailsName="send_product_update_emails"
            />
          </tbody>
        </table>
      </div>
    </div>
  )
}
